import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=816e8f14&lang=pug&"
import script from "./DataTablePagination.vue?vue&type=script&lang=js&"
export * from "./DataTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DataTablePagination.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VPagination,
  VSelect,
})
